{
  "login": "ログイン",
  "logout": "ログアウト",
  "signOut": "ログアウト",
  "username": "ユーザー名",
  "password": "パスワード",
  "forgotPassword": "パスワードをお忘れですか？",
  "rememberMe": "ログイン状態を保持する",
  "loginButton": "サインイン",
  "loginError": "ユーザー名またはパスワードが正しくありません",
  "sessionExpired": "セッションが期限切れです。再度ログインしてください。",
  "passwordChangedRelogin": "Your password was changed. Please sign in with your new password.",
  "signingIn": "サインイン中...",
  "loginSuccess": "ログインに成功しました",
  "showPassword": "パスワードを表示",
  "hidePassword": "パスワードを非表示",
  "onboardingPrompt": "病院・クリニックをお持ちですか?",
  "onboardingCta": "導入を申請する",
  "loginFailed": "ログインに失敗しました",
  "seatCapReached": "このライセンスのユーザー上限に達しました。管理者に連絡してください。",
  "mfaCodeLabel": "確認コード",
  "mfaCodePrompt": "認証アプリに表示される6桁のコードを入力してログインを完了してください。",
  "mfaSetupRequired": "所属組織では多要素認証が必須です。続行するには認証アプリを設定してください。",
  "mfaCodePlaceholder": "6桁のコード",
  "mfaInvalidCode": "確認コードが正しくありません",
  "pages": {
    "userProfile": {
      "title": "プロフィール",
      "loading": "プロフィールを読み込み中...",
      "sections": {
        "profilePicture": "プロフィール画像",
        "personalInformation": "個人情報",
        "changePassword": "パスワード変更",
        "multiFactorAuth": "多要素認証"
      },
      "fields": {
        "fullName": "氏名",
        "email": "メールアドレス",
        "phone": "電話番号",
        "currentPassword": "現在のパスワード",
        "newPassword": "新しいパスワード",
        "confirmPassword": "新しいパスワード（確認）",
        "required": "*"
      },
      "actions": {
        "saveChanges": "変更を保存",
        "changePassword": "パスワードを変更",
        "setUpMfa": "多要素認証を設定",
        "uploadAvatar": "アップロード",
        "changeAvatar": "変更",
        "removeAvatar": "削除",
        "verify": "確認"
      },
      "avatar": {
        "alt": "アバター",
        "helperText": "PNG、JPEG、WebP 形式、4 MB まで。アップロード前に {{size}}×{{size}} にリサイズされます。"
      },
      "mfa": {
        "enabledMessage": "多要素認証はアカウントで有効になっています。",
        "intro": "多要素認証を有効にして、アカウントのセキュリティを強化しましょう。",
        "scanInstruction": "このURIを認証アプリでスキャンするか、手動でコピーしてください：",
        "copyUri": "URIをコピー",
        "verificationCode": "認証コード",
        "codePlaceholder": "6桁のコードを入力"
      },
      "validation": {
        "fullNameRequired": "氏名は必須です",
        "emailRequired": "有効なメールアドレスを入力してください",
        "currentPasswordRequired": "現在のパスワードは必須です",
        "newPasswordTooShort": "パスワードは8文字以上で入力してください",
        "confirmPasswordRequired": "確認用パスワードを入力してください",
        "passwordsMismatch": "パスワードが一致しません"
      },
      "toasts": {
        "profileUpdated": "プロフィールを更新しました",
        "profileUpdateFailed": "プロフィールの更新に失敗しました",
        "passwordChanged": "パスワードを変更しました",
        "passwordChangeFailed": "パスワードの変更に失敗しました。現在のパスワードをご確認ください。",
        "mfaSetupFailed": "多要素認証の設定開始に失敗しました",
        "mfaEnabled": "多要素認証を有効にしました",
        "mfaInvalidCode": "認証コードが正しくありません",
        "avatarUpdated": "アバターを更新しました",
        "avatarUpdateFailed": "アバターの更新に失敗しました",
        "avatarRemoved": "アバターを削除しました",
        "avatarRemoveFailed": "アバターの削除に失敗しました",
        "imageTooLarge": "画像は4 MB以下にしてください",
        "imageTooLargeServer": "画像が大きすぎます。より小さいファイルをお試しください",
        "copiedToClipboard": "クリップボードにコピーしました"
      }
    }
  },
  "components": {
    "sessionTimeoutWarning": {
      "critical": "セッションは1分以内に期限切れになります。作業を保存してください。",
      "expiringSoon_one": "セッションはあと{{count}}分で期限切れになります。",
      "expiringSoon_other": "セッションはあと{{count}}分で期限切れになります。",
      "extendButton": "セッションを延長"
    }
  },
  "signInMethod": "Sign-in method",
  "signInPassword": "Password",
  "signInDirectory": "Directory",
  "signInSso": "SSO",
  "ldapDirectory": "Directory",
  "ldapLoading": "Loading directories…",
  "ldapEmpty": "No directories configured — contact your administrator.",
  "ssoEmail": "Work email",
  "ssoEmailPlaceholder": "you@hospital.org",
  "ssoContinue": "Continue with SSO",
  "ssoChecking": "Checking…",
  "ssoChoose": "Choose your sign-in provider",
  "ssoContinueWith": "Continue with {{name}}",
  "ssoNoneFound": "No SSO provider for this domain — try password or directory sign-in.",
  "ssoCallbackTitle": "Completing sign-in…",
  "ssoCallbackFailed": "Single sign-on failed",
  "ssoCallbackMissing": "Missing sign-in response — please try again.",
  "ssoBackToLogin": "Back to sign-in",
  "setup": {
    "title": "初期セットアップ",
    "subtitle": "このインストール用の最初の管理者アカウントを作成します。",
    "username": "ユーザー名",
    "password": "パスワード",
    "confirmPassword": "パスワードの確認",
    "fullName": "氏名（任意）",
    "fullNamePlaceholder": "例：山田 太郎",
    "email": "メールアドレス（任意）",
    "submit": "管理者アカウントを作成",
    "submitting": "アカウントを作成しています…",
    "usernameHint": "3～64文字：小文字、数字、ドット、アンダースコア、ハイフン。",
    "passwordHint": "12文字以上。大文字・小文字・数字・記号を含めてください。",
    "errUsername": "3～64文字で入力してください：a–z、0–9、ドット、アンダースコア、ハイフン。",
    "errPasswordLength": "パスワードは12文字以上で入力してください。",
    "errPasswordUpper": "パスワードには大文字を含めてください。",
    "errPasswordLower": "パスワードには小文字を含めてください。",
    "errPasswordDigit": "パスワードには数字を含めてください。",
    "errPasswordSpecial": "パスワードには記号を含めてください。",
    "errConfirmRequired": "パスワードを確認入力してください。",
    "errConfirmMismatch": "パスワードが一致しません。",
    "errFullName": "氏名は100文字以内で入力してください。",
    "errEmail": "有効なメールアドレスを入力してください。",
    "successTitle": "管理者アカウントを作成しました",
    "successBody": "アカウント「{{username}}」の準備ができました。サインインして続行してください。",
    "goToLogin": "サインインへ",
    "claimedTitle": "セットアップは完了済みです",
    "claimedBody": "このシステムには既に管理者がいます。お持ちのアカウントでサインインしてください。",
    "networkError": "サーバーに接続できませんでした。接続を確認して再試行してください。",
    "retry": "再試行",
    "rateLimited": "試行回数が多すぎます。1分ほど待ってから再試行してください。",
    "usernameTaken": "このユーザー名は既に使用されています。",
    "submitFailed": "アカウントを作成できませんでした。もう一度お試しください。"
  }
}
